/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, FormControl } from "@mui/material";
import LabelledField from "components/labelled-field/index";
import { isArrayNotEmpty, isFalse, isTrue, isValidOption } from "utils/empty-exists";

const SettingsTargetEdit = (props) => {

    const { t } = useTranslation();
    const label = props?.label;
    const itemLocalState = props?.itemLocalState;
    const setItemLocalState = props?.setItemLocalState;
    const schemaOptions = props?.schemaOptions;
    const disabled = props?.disabled;
    const index = props?.index;
    const update = props?.update;
    const selected = props?.selected ?? "field.target.tab";
    const _option = itemLocalState?.settings?.options?.openIn;
    const openInValue = isValidOption(_option, schemaOptions) ? _option : "field.target.tab";
    const targets = schemaOptions?.targets;

    const onChangeTarget = (event) => {
        // use new value unless none was selected
        const value = event.target.value;
        let updatedValue = (value !== null) ? value : selected;
        updatedValue = (updatedValue !== "field.target.none") ? updatedValue : selected;
        const newState = {
            ...itemLocalState,
            value: itemLocalState?.value || "",
            settings: {
                style: itemLocalState?.settings.style,
                format: itemLocalState?.settings.format,
                options: { ...itemLocalState?.settings?.options, openIn: updatedValue },
            },
        };
        setItemLocalState(newState);
        update(newState,index);
    };
    
    return (
        <Fragment>
            {isFalse(disabled) &&
                <LabelledField label={label ? label : t("commons.openIn")} className='labelField'>
                    {isArrayNotEmpty(targets) &&
                        <FormControl sx={{ mt: 1, mb: 1, width: "100%" }} size="small">
                            <Select
                                labelId='demo-select-small-label'
                                id='link-style-select'
                                value={openInValue}
                                fullWidth={true}
                                disabled={disabled}
                                variant='standard'
                                onChange={(e) => onChangeTarget(e)}
                            >
                                {openInValue === "field.target.none" || openInValue === "" &&
                                    <MenuItem value={"field.target.none"}>Select...</MenuItem>
                                }
                                {targets.map((option, index) =>
                                    <MenuItem key={index} value={option?.value}>{option?.name}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    }
                </LabelledField>
            }
            {/*<p>{openInValue}</p>*/}
            {/*<p>{JSON.stringify(schemaOptions, null,2)}</p>*/}
            {isTrue(disabled) &&
                <div
                    style={{
                        width: "100%",
                        height: "64px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#7A7A7A",
                    }}
                >
                    {t("commons.thisContentIsNotForDisplay")}
                </div>
            }
        </Fragment>
    );
};

export { SettingsTargetEdit };
